import { call, put, takeLatest } from "redux-saga/effects";
import {
  loginAnotherWaySuccess,
  loginAnotherWayFailure,
} from "../../action/loginAnotherWay";
import { LOGIN_ANOTHER_WAY_REQUEST } from "../../actionTypes/loginAnotherWay";
import { loginAnotherWayApi } from "../../../com/loginAnotherWay";
import { BaseResponse } from "../../response";
import { API_CODES } from "../../../constants";

interface LoginAnotherWayAction {
  type: typeof LOGIN_ANOTHER_WAY_REQUEST;
  payload: { emailOrPhone: string };
}

export function* handleLoginAnotherWay(
  action: LoginAnotherWayAction,
): Generator<unknown, void, BaseResponse> {
  try {
    const response = yield call(loginAnotherWayApi, action.payload);

    if (response.status === API_CODES.SUCCESS_CODE || response.status === "SUCCESS") {
      yield put(loginAnotherWaySuccess(response.statusinfo.message));
    } else {
      yield put(loginAnotherWayFailure(response.statusinfo.message));
    }
  } catch {
    yield put(loginAnotherWayFailure("Please try again Later"));
  }
}

export function* loginAnotherWaySaga(): Generator {
  yield takeLatest(LOGIN_ANOTHER_WAY_REQUEST, handleLoginAnotherWay);
}
